import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'

import {Login} from './components/Login/Login'
import ForgotPassword from './components/ForgotPassword'
import Registration from './components/Registration'
import ConfirmAccount from './components/ConfirmAccount'
import './AuthPage.scss'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed auth-layout'
      style={{backgroundColor: 'whitesmoke'}}
    >
      <div className='d-flex flex-column flex-column-fluid auth-layout__inner'>
        <div className='logo-login auth-layout__logo' aria-hidden='true' />
        <div className='bg-body rounded shadow-sm mx-auto auth-layout__card'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='/registration' element={<Registration />} />
      <Route path='/registration/confirm' element={<ConfirmAccount />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/forgot-password/*' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
